import { ReactNode } from 'react';

import { Navbar } from '@/components/Navbar/Navbar';
import { twJoin } from '@/utils/tw-merge';

export const ErrorTemplate = ({
  svg,
  title,
  description,
  button,
  direction = 'ltr',
}: {
  direction: 'ltr' | 'rtl';
  svg: ReactNode;
  title: string;
  description: ReactNode;
  button?: ReactNode;
}) => {
  return (
    <div className="bg-gray-50">
      <Navbar />

      <main className="container-default pt-10">
        <div
          className={twJoin(
            'flex items-center gap-2 px-10',
            direction === 'ltr' && 'flex-row-reverse'
          )}
        >
          <div className="basis-1/2">{svg}</div>

          <div className="max-w-[48rem]">
            <h1 className="style-h1 mb-1 text-black">{title}</h1>

            <div className="style-h3 mb-3 text-gray-700">{description}</div>

            {button}
          </div>
        </div>
      </main>
    </div>
  );
};
